import React from 'react';
import { Col, Row } from 'reactstrap';
import { InputFormField } from '../../../../../../../../../components/InputFormField';
import { UseFormRegister } from 'react-hook-form';
import { LocationValue } from '../..';

interface PropTypes {
  register: UseFormRegister<LocationValue>;
}

export function LocationNameInputRow(props: PropTypes) {
  return (
    <Row className='mb-3'>
      <Col sm={12}>
        <InputFormField
          type={'text'}
          registerReturn={props.register('locationName', {
            required: true,
          })}
          fieldName={'Location Name'}
          placeholder={'Add a location name (e.g., London - Main Office)'}
          isRequired={true}
          maxLength={32}
          showMaxLengthCounter={true}
        />
      </Col>
    </Row>
  );
}
